import { useContext } from 'react'

import InvertedColorsContext from '@contexts/invertedColors'

const useHasInvertedColors = (): boolean => !!useContext(InvertedColorsContext)

export default useHasInvertedColors
